import {
  getAuth,
  signInAnonymously,
  signInWithCustomToken,
  onAuthStateChanged,
} from 'firebase/auth';
import {AuthService, AuthStateChangedCallback} from '.';
import {IApiService, Platform} from '../api';

export class FirebaseAuthService implements AuthService {
  constructor(protected api: IApiService) {}

  async signOut(): Promise<void> {
    return await getAuth().signOut();
  }

  public async signInAnonymously() {
    return await signInAnonymously(getAuth());
  }

  public async signInWithCustomToken(token: string): Promise<void> {
    await signInWithCustomToken(getAuth(), token);
  }

  public onAuthStateChanged(callback: AuthStateChangedCallback) {
    return onAuthStateChanged(getAuth(), callback);
  }

  public async getIdToken(): Promise<string | null> {
    const currentUser = getAuth().currentUser;
    if (!currentUser) {
      return null;
    }

    return await currentUser.getIdToken();
  }

  public async finishLogin({
    isSignUp,
    name,
  }: {
    isSignUp: boolean;
    name: string | null;
  }): Promise<void> {
    await this.api.user.finishLogin({
      data: {
        platform: Platform.web,
        deviceId: null,
        upgraded: isSignUp,
        name,
      },
    });
  }
}
